"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
var _util = _interopRequireDefault(require("./util"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
/**
 * @class Member
 */
var Member = /*#__PURE__*/function () {
  /**
   * @param {Object} participant - the locus participant
   * @param {Object} [options] - constructor params
   * @param {String} options.selfId
   * @param {String} options.hostId
   * @param {String} options.contentSharingId
   * @param {String} options.type
   * @returns {Member}
   * @memberof Member
   */
  function Member(participant) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2.default)(this, Member);
    (0, _defineProperty2.default)(this, "associatedUser", void 0);
    (0, _defineProperty2.default)(this, "id", void 0);
    (0, _defineProperty2.default)(this, "isAudioMuted", void 0);
    (0, _defineProperty2.default)(this, "isContentSharing", void 0);
    (0, _defineProperty2.default)(this, "isDevice", void 0);
    (0, _defineProperty2.default)(this, "isGuest", void 0);
    (0, _defineProperty2.default)(this, "isHandRaised", void 0);
    (0, _defineProperty2.default)(this, "isHost", void 0);
    (0, _defineProperty2.default)(this, "isInLobby", void 0);
    (0, _defineProperty2.default)(this, "isInMeeting", void 0);
    (0, _defineProperty2.default)(this, "isModerator", void 0);
    (0, _defineProperty2.default)(this, "isModeratorAssignmentProhibited", void 0);
    (0, _defineProperty2.default)(this, "isMutable", void 0);
    (0, _defineProperty2.default)(this, "isNotAdmitted", void 0);
    (0, _defineProperty2.default)(this, "isRecording", void 0);
    (0, _defineProperty2.default)(this, "isRemovable", void 0);
    (0, _defineProperty2.default)(this, "isSelf", void 0);
    (0, _defineProperty2.default)(this, "isUser", void 0);
    (0, _defineProperty2.default)(this, "isVideoMuted", void 0);
    (0, _defineProperty2.default)(this, "mediaStatus", void 0);
    (0, _defineProperty2.default)(this, "name", void 0);
    (0, _defineProperty2.default)(this, "participant", void 0);
    (0, _defineProperty2.default)(this, "status", void 0);
    (0, _defineProperty2.default)(this, "type", void 0);
    (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
    /**
     * The server participant object
     * @instance
     * @type {Object}
     * @private
     * @memberof Member
     */
    this.participant = null;
    /**
     * The member id
     * @instance
     * @type {String}
     * @public
     * @memberof Member
     */
    this.id = null;
    /**
     * The member name
     * @instance
     * @type {String}
     * @public
     * @memberof Member
     */
    this.name = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isAudioMuted = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isVideoMuted = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isHandRaised = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isSelf = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isHost = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isGuest = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isInLobby = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isInMeeting = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isNotAdmitted = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isContentSharing = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.status = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isDevice = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isUser = null;
    /**
     * Is this member associated to another user by way of pairing (typical of devices)
     * @instance
     * @type {String}
     * @public
     * @memberof Member
     */
    this.associatedUser = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isRecording = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isMutable = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isRemovable = null;
    /**
     * @instance
     * @type {String}
     * @private
     * @memberof Member
     */
    this.type = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isModerator = null;
    /**
     * @instance
     * @type {Boolean}
     * @public
     * @memberof Member
     */
    this.isModeratorAssignmentProhibited = null;
    /**
     * @instance
     * @type {IMediaStatus}
     * @public
     * @memberof Member
     * @example {audio: MediaStatus.RECVONLY, video: MediaStatus.SENDRECV}
     */
    this.mediaStatus = {
      audio: null,
      video: null
    };
    // TODO: more participant types
    // such as native client, web client, is a device, what type of phone, etc
    this.processParticipant(participant);
    this.processParticipantOptions(participant, options);
    this.processMember();
  }

  /**
   * set all the participant values extracted directly from locus participant
   * @param {Object} participant the locus participant object
   * @returns {undefined}
   * @private
   * @memberof Member
   */
  (0, _createClass2.default)(Member, [{
    key: "processParticipant",
    value: function processParticipant(participant) {
      this.participant = participant;
      if (participant) {
        this.id = _util.default.extractId(participant);
        this.name = _util.default.extractName(participant);
        this.isAudioMuted = _util.default.isAudioMuted(participant);
        this.isVideoMuted = _util.default.isVideoMuted(participant);
        this.isHandRaised = _util.default.isHandRaised(participant);
        this.isGuest = _util.default.isGuest(participant);
        this.isUser = _util.default.isUser(participant);
        this.isDevice = _util.default.isDevice(participant);
        this.isModerator = _util.default.isModerator(participant);
        this.isModeratorAssignmentProhibited = _util.default.isModeratorAssignmentProhibited(participant);
        this.processStatus(participant);
        // must be done last
        this.isNotAdmitted = _util.default.isNotAdmitted(participant, this.isGuest, this.status);
      }
    }

    /**
     * Use the members options and participant values to set on the member
     * @param {Object} participant the locus participant object
     * @param {Object} options the passed in options, what was set on members
     * @returns {undefined}
     * @private
     * @memberof Member
     */
  }, {
    key: "processParticipantOptions",
    value: function processParticipantOptions(participant, options) {
      if (participant && options) {
        this.processIsSelf(participant, options.selfId);
        this.processIsHost(participant, options.hostId);
        this.processIsContentSharing(participant, options.contentSharingId);
        this.processType(options.type);
        this.processIsRecording(participant, options.recordingId);
      }
    }

    /**
     * processes what already exists on the member to determine other info about the member
     * @returns {undefined}
     * @private
     * @memberof Member
     */
  }, {
    key: "processMember",
    value: function processMember() {
      // must occur after self, guest, meeting, and type properties are calculated
      this.isRemovable = _util.default.isRemovable(this.isSelf, this.isGuest, this.isInMeeting, this.type);
      // must occur after self, device, meeting, mute status, and type properties are calculated
      this.isMutable = _util.default.isMutable(this.isSelf, this.isDevice, this.isInMeeting, this.isAudioMuted, this.type);
      this.mediaStatus = _util.default.extractMediaStatus(this.participant);
    }

    /**
     * set the status on member object
     * @param {Object} participant the locus participant object
     * @returns {undefined}
     * @private
     * @memberof Member
     */
  }, {
    key: "processStatus",
    value: function processStatus(participant) {
      this.status = _util.default.extractStatus(participant);
      switch (this.status) {
        case _constants._IN_LOBBY_:
          this.isInLobby = true;
          this.isInMeeting = false;
          break;
        case _constants._IN_MEETING_:
          this.isInLobby = false;
          this.isInMeeting = true;
          break;
        case _constants._NOT_IN_MEETING_:
          this.isInLobby = false;
          this.isInMeeting = false;
          break;
        default:
          this.isInLobby = false;
          this.isInMeeting = false;
      }
    }

    /**
     * set the isContentSharing on member
     * @param {Boolean} flag
     * @returns {undefined}
     * @public
     * @memberof Member
     */
  }, {
    key: "setIsContentSharing",
    value: function setIsContentSharing(flag) {
      this.isContentSharing = flag;
    }

    /**
     * set the isHost on member
     * @param {Boolean} flag
     * @returns {undefined}
     * @public
     * @memberof Member
     */
  }, {
    key: "setIsHost",
    value: function setIsHost(flag) {
      this.isHost = flag;
    }

    /**
     * set the isSelf on member
     * @param {Boolean} flag
     * @returns {undefined}
     * @public
     * @memberof Member
     */
  }, {
    key: "setIsSelf",
    value: function setIsSelf(flag) {
      this.isSelf = flag;
    }

    /**
     * determine if this member is content sharing
     * @param {Object} participant
     * @param {String} sharingId
     * @returns {undefined}
     * @public
     * @memberof Member
     */
  }, {
    key: "processIsContentSharing",
    value: function processIsContentSharing(participant, sharingId) {
      if (_util.default.isUser(participant)) {
        this.isContentSharing = _util.default.isSame(participant, sharingId);
      } else if (_util.default.isDevice(participant)) {
        this.isContentSharing = _util.default.isAssociatedSame(participant, sharingId);
      }
    }

    /**
     * Determine if this member is recording
     * @param {Object} participant
     * @param {String} recordingId
     * @returns {undefined}
     * @public
     * @memberof Member
     */
  }, {
    key: "processIsRecording",
    value: function processIsRecording(participant, recordingId) {
      this.isRecording = _util.default.isSame(participant, recordingId);
    }

    /**
     * determine if this member is the self
     * @param {Object} participant
     * @param {String} selfId
     * @returns {undefined}
     * @private
     * @memberof Member
     */
  }, {
    key: "processIsSelf",
    value: function processIsSelf(participant, selfId) {
      if (_util.default.isUser(participant)) {
        this.isSelf = _util.default.isSame(participant, selfId);
      } else if (_util.default.isDevice(participant)) {
        this.isSelf = _util.default.isAssociatedSame(participant, selfId);
        this.associatedUser = selfId;
      }
    }

    /**
     * determine if this member is the host
     * @param {Object} participant
     * @param {String} hostId
     * @returns {undefined}
     * @private
     * @memberof Member
     */
  }, {
    key: "processIsHost",
    value: function processIsHost(participant, hostId) {
      if (_util.default.isUser(participant)) {
        this.isHost = _util.default.isSame(participant, hostId);
      } else if (_util.default.isDevice(participant)) {
        this.isHost = _util.default.isAssociatedSame(participant, hostId);
      }
    }

    /**
     * set the type for the member, could be MEETING or CALL
     * @param {String} type
     * @returns {undefined}
     * @private
     * @memberof Member
     */
  }, {
    key: "processType",
    value: function processType(type) {
      this.type = type;
    }
  }]);
  return Member;
}();
exports.default = Member;
//# sourceMappingURL=index.js.map
